import React, { useState } from 'react';
import InfiniteScrollDefaultLoader from './InfiniteScrollDefaultLoader';
import { Waypoint } from './Waypoint';

export interface InfiniteScrollProps {
    children: React.ReactNode;
    next: () => Promise<any>;
    hasMore: boolean;
    endMessage?: React.ReactNode;
}

export const InfiniteScroll = ({ children, next, hasMore, endMessage }: InfiniteScrollProps) => {
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const fetchMoreData = async () => {
        try {
            setIsLoading(true);
            await next();
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="flex flex-col">
            {children}
            {isLoading && <InfiniteScrollDefaultLoader />}
            {!isLoading && hasMore && <Waypoint onEnter={() => fetchMoreData()} />}
            {!hasMore && endMessage}
        </div>
    );
};
